export default __webpack_public_path__ + "static/media/right_flatFoot.15ca3143.png";